import { render, staticRenderFns } from "./err.vue?vue&type=template&id=0f51b08c&scoped=true&"
import script from "./err.vue?vue&type=script&lang=js&"
export * from "./err.vue?vue&type=script&lang=js&"
import style0 from "./err.vue?vue&type=style&index=0&id=0f51b08c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51b08c",
  null
  
)

export default component.exports